import { getSingleActiveViewerMode, getViewerUrl } from './mode';

/* Wraps the app boot in `src/index.ts`. With the PoC off (the default) it only
 * calls `bootApp`. `src/index.ts` imports this statically, so it stays in the
 * entry chunk: keep its imports to `./mode` and load the rest dynamically. */
export const bootWithSingleActiveViewer = (bootApp: () => void): void => {
  // `off` unless the user enabled it with `?exoPocSingleViewer=1`.
  const mode = getSingleActiveViewerMode();

  if (mode === 'parked') {
    // The parked page is the lightweight view: skip the app entirely.
    void import(
      /* webpackChunkName: "poc-single-viewer-parked" */ './parkedView'
    )
      .then(({ renderParkedView }) => renderParkedView())
      // The parked page failed to load or render: boot the app normally instead.
      .catch(() => window.location.replace(getViewerUrl(window.location.href)));
    return;
  }

  bootApp();

  if (mode === 'on') {
    void import(
      /* webpackChunkName: "poc-single-viewer-claim" */ './viewerClaim'
    )
      .then(({ startViewerClaim }) => startViewerClaim())
      // The PoC is optional; a failed chunk must not surface as an app error.
      .catch(() => undefined);
  }
};
